import { ZfCheckbox, ZfLoadingSpinner } from '@zafire/react';
import type { ColDef, ICellRendererParams } from 'ag-grid-enterprise';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDomiciles, useUpdateDomicile } from '../../api';
import type { DomicileDto } from '../../api/generated/client';
import { AdminContentBox } from '../../components/admin';
import { AgGridTable } from '../../components/atoms';

export const AdminDomiciles = () => {
    const { t } = useTranslation();
    const { data: domiciles = [], isLoading } = useDomiciles();
    const { mutate: updateDomicile } = useUpdateDomicile();

    const onDomicileEnableChange = useCallback((domicile: DomicileDto, enabled: boolean) => updateDomicile({ ...domicile, enabled }), [updateDomicile]);

    const columnDefs: ColDef<DomicileDto>[] = [
        {
            field: 'enabled',
            headerName: t('contentAdmin.domicileTableColumnEnabled'),
            sortable: false,
            cellRenderer: ({ value, data }: ICellRendererParams<DomicileDto, boolean>) => (
                <ZfCheckbox checked={!!value} onCheckboxCheck={(e) => onDomicileEnableChange(data!, e.detail)} />
            ),
        },
        {
            field: 'countryName',
            headerName: t('contentAdmin.domicileTableColumnName'),
            flex: 1,
        },
        {
            field: 'isoAlpha2',
            headerName: t('contentAdmin.domicileTableColumnIso'),
            flex: 1,
        },
    ];

    if (isLoading) return <ZfLoadingSpinner style={{ margin: 'auto' }} />;

    return (
        <AdminContentBox>
            <AgGridTable
                rowData={domiciles}
                columnDefs={columnDefs}
                defaultColDef={{
                    resizable: false,
                    cellStyle: { display: 'flex', alignItems: 'center' },
                }}
                emptyTablePlaceholderText={t('contentAdmin.noDomicilesAvailable')}
            />
        </AdminContentBox>
    );
};
